import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class SidebarRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_type: this.props.user_type,
    };
  }

  render() {
    // console.log('SidebarRole user_type=' + this.state.user_type);
    if (this.state.user_type === "admin") {
      return (
        <ul className="nav">
          <li className="nav-item">
            <NavLink
              to={"/dashboard/admin"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> Dashboard
              <span className="badge badge-info">NEW</span>
            </NavLink>
          </li>
          <li className="nav-title">เมนู</li>

          <li className="nav-item">
            <NavLink
              to={"/cars/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-key"></i> ข้อมูลรถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/carcheck/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-check"></i> ประเมินทำสีรถ{" "}
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/customer/followup/tab"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-follow"></i> ติดตามลูกค้า{" "}
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/sparepart"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลอะไหล่
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/car-repair/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลส่งซ่อม
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/customer/findcar"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-energy"></i> ข้อมูลลูกค้าหารถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/customer/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-following"></i> ข้อมูลลูกค้า
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/customer/credit-profile"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-following"></i> ข้อมูลเครดิตลูกค้า
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/car-reservation/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-diamond"></i> ข้อมูลการจองรถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/sales/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-paypal"></i> ข้อมูลการขาย
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/car-claim/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลส่งเคลม/รับรถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/debtors/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-people"></i> ข้อมูลลูกหนี้ค้างดาวน์
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/receipts/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-bulb"></i> รายรับของเต็นท์รถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/expense/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wallet"></i> ค่าใช้จ่ายของเต็นท์รถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/expense/repair"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wallet"></i> ค่าใช้จ่ายซ่อมรถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/employee/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-tag"></i> ข้อมูลพนักงาน
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/calendar/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-calendar"></i> ปฏิทินเตือนความจำ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/branch/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-grid"></i> ข้อมูลสาขา
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/bank/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-list"></i> ข้อมูลรายการธนาคาร
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/maintenance/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> ข้อมูลศูนย์ซ่อมบำรุงรถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/account/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-shield"></i> กำหนดสิทธิ์ผู้ใช้งาน
            </NavLink>
          </li>
        </ul>
      );
    } else if (this.state.user_type === "manager") {
      return (
        <ul className="nav">
          <li className="nav-item">
            <NavLink
              to={"/dashboard"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> Dashboard{" "}
              <span className="badge badge-info">NEW</span>
            </NavLink>
          </li>
          <li className="nav-title">เมนู</li>

          <li className="nav-item">
            <NavLink
              to={"/calendar/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-calendar"></i> ปฏิทินเตือนความจำ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/cars/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-key"></i> ข้อมูลรถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/sparepart"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลอะไหล่
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/car-repair/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลส่งซ่อม
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/customer/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-following"></i> ข้อมูลลูกค้า
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/customer/credit-profile"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-following"></i> ข้อมูลเครดิตลูกค้า
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/agent/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-following"></i> ข้อมูลนายหน้า
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/customer/findcar"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-energy"></i> ข้อมูลลูกค้าหารถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/car-reservation/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-diamond"></i> ข้อมูลการจองรถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/sales/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-paypal"></i> ข้อมูลการขาย
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/car-claim/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลส่งเคลม/รับรถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/debtors/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-people"></i> ข้อมูลลูกหนี้{" "}
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/receipts/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-bulb"></i> รายรับของเต็นท์รถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/expense/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wallet"></i> ค่าใช้จ่ายของเต็นท์รถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/expense/repair"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wallet"></i> ค่าใช้จ่ายซ่อมรถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/expense/car/other"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wallet"></i> ข้อมูลค่าใช้จ่ายอื่นๆ ของรถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/employee/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-tag"></i> ข้อมูลพนักงาน
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/branch/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-grid"></i> ข้อมูลสาขา
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/bank/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-list"></i> ข้อมูลรายการธนาคาร
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/maintenance/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> ข้อมูลศูนย์ซ่อมบำรุงรถ
            </NavLink>
          </li>
        </ul>
      );
    } else if (this.state.user_type === "sale") {
      return (
        <ul className="nav">
          <li className="nav-item">
            <NavLink
              to={"/dashboard/sale"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> Dashboard{" "}
              <span className="badge badge-info">NEW</span>
            </NavLink>
          </li>
          <li className="nav-title">เมนู</li>
          <li className="nav-item">
            <NavLink
              to={"/cars/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-key"></i> ข้อมูลรถ
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/customer/followup/tab"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-follow"></i> ติดตามลูกค้า{" "}
            </NavLink>
          </li>

          {/*<li className="nav-item">
            <NavLink to={'/customer/list'} className="nav-link" activeClassName="active"><i
              className="icon-user-following"></i> ข้อมูลลูกค้า</NavLink>
          </li>*/}

          <li className="nav-item">
            <NavLink
              to={"/customer/credit-profile"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-user-following"></i> ข้อมูลเครดิตลูกค้า
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to={"/customer/findcar"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-energy"></i> ข้อมูลลูกค้าหารถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/car-reservation/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-diamond"></i> ข้อมูลการจองรถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/sales/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-paypal"></i> ข้อมูลการขาย
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/car-claim/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลส่งเคลม/รับรถ
            </NavLink>
          </li>
        </ul>
      );
    } else if (this.state.user_type === "subsale") {
      return (
        <ul className="nav">
          <li className="nav-item">
            <NavLink
              to={"/dashboard/sale"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> Dashboard{" "}
              <span className="badge badge-info">NEW</span>
            </NavLink>
          </li>
          <li className="nav-title">เมนู</li>
          <li className="nav-item">
            <NavLink
              to={"/cars/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-key"></i> ข้อมูลรถ
            </NavLink>
          </li>
          {/* <li className="nav-item">
            <NavLink to={'/customer/list'} className="nav-link" activeClassName="active"><i
              className="icon-user-following"></i> ข้อมูลลูกค้า</NavLink>
          </li>*/}
          <li className="nav-item">
            <NavLink
              to={"/customer/findcar"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-energy"></i> ข้อมูลลูกค้าหารถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/car-reservation/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-diamond"></i> ข้อมูลการจองรถ
            </NavLink>
          </li>
          {/* <li className="nav-item">
            <NavLink to={'/sales/list'} className="nav-link" activeClassName="active"><i
              className="icon-paypal"></i> ข้อมูลการขาย</NavLink>
          </li>*/}
          {/*<li className="nav-item">
            <NavLink to={'/car-claim/list'} className="nav-link" activeClassName="active"><i
              className="icon-wrench"></i> ข้อมูลส่งเคลม/รับรถ</NavLink>
          </li>*/}
        </ul>
      );
    } else if (this.state.user_type === "freelance") {
      return (
        <ul className="nav">
          <li className="nav-title">เมนู</li>
          <li className="nav-item">
            <NavLink
              to={"/cars/freelance"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-key"></i> ข้อมูลรถ
            </NavLink>
          </li>
        </ul>
      );
    } else {
      //if(this.state.user_type === 'technician'){
      return (
        <ul className="nav">
          <li className="nav-item">
            <NavLink
              to={"/cars/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> Dashboard{" "}
              <span className="badge badge-info">NEW</span>
            </NavLink>
          </li>
          <li className="nav-title">เมนู</li>
          <li className="nav-item">
            <NavLink
              to={"/cars/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-key"></i> ข้อมูลรถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/car-repair/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลส่งซ่อมรถมาใหม่
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/car-claim/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-wrench"></i> ข้อมูลส่งเคลม/รับรถ
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to={"/maintenance/list"}
              className="nav-link"
              activeClassName="active"
            >
              <i className="icon-speedometer"></i> ข้อมูลศูนย์ซ่อมบำรุงรถ
            </NavLink>
          </li>
        </ul>
      );
    }
  }
}

export default SidebarRole;
